import { render, staticRenderFns } from "./AsMainWorkorderLIst.vue?vue&type=template&id=4567e990"
import script from "./AsMainWorkorderLIst.vue?vue&type=script&lang=js"
export * from "./AsMainWorkorderLIst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports